'use es6';

import PropTypes from 'prop-types';
export default PropTypes.shape({
  fetch: PropTypes.func.isRequired,
  getFetcherFromProps: PropTypes.func.isRequired,
  isAssetFamilySupported: PropTypes.func.isRequired,
  updater: PropTypes.func.isRequired
});